<div mat-dialog-content class="flex-grow p-0">
    <div class="flex flex-col h-full">
        <div
            cdkDropList
            #availableOSList="cdkDropList"
            [cdkDropListData]="currentSkill.dispositions"
            class="example-list"
            (cdkDropListDropped)="drop($event)">
            <div class="example-box justify-between items-center p-2" *ngFor="let item of currentSkill.dispositions" cdkDrag>
                {{item.dispositionName}}
                <div>
                    <span (click)="removeDisposition(item)" style="cursor: pointer"><mat-icon matTooltip="Remove Disposition">delete</mat-icon></span>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="flex flex-row justify-around p-1">
    <button mat-raised-button color="accent" (click)="onDismiss()" mat-dialog-close>Cancel</button>
    <button mat-raised-button color="primary" (click)="onConfirm()">Confirm</button>
</div>

